// Carga perezosa del Square Web Payments SDK (tokeniza tarjetas en el
// navegador; el número de tarjeta nunca llega a nuestro backend).
let sdkPromise = null;
let loadedEnvironment = null;

export function loadSquareSdk(environment) {
  if (window.Square && loadedEnvironment === environment) {
    return Promise.resolve(window.Square);
  }
  if (sdkPromise && loadedEnvironment === environment) {
    return sdkPromise;
  }
  loadedEnvironment = environment;
  const src = environment === 'production'
    ? 'https://web.squarecdn.com/v1/square.js'
    : 'https://sandbox.web.squarecdn.com/v1/square.js';
  sdkPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing && window.Square) {
      resolve(window.Square);
      return;
    }
    const script = document.createElement('script');
    script.src = src;
    script.onload = () => resolve(window.Square);
    script.onerror = () => reject(new Error('No se pudo cargar el SDK de pagos de Square'));
    document.body.appendChild(script);
  });
  return sdkPromise;
}

export const SQUARE_TEST_CARD_HINT = '4111 1111 1111 1111 \u00b7 CVV 111 \u00b7 cualquier fecha futura (tarjeta de prueba, solo Sandbox)';
